<template>
  <v-card>
    <ToolbarTitles :title="title" class="ma-4 py-2" />
    <v-card class="mx-4">
      <v-card-title
        style="background-color: #82a1d0"
        background-color="primary"
        class="d-flex justify-space-between align-center"
      >
        <v-text-field
          dense
          solo
          v-model="search"
          append-icon="mdi-magnify"
          :label="$tc('commons.search')"
          single-line
          hide-details
          class="search"
        ></v-text-field>
        <v-menu
          bottom
          origin="center center"
          transition="scale-transition"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <v-icon dark v-bind="attrs" v-on="{ ...tooltip, ...menu }"
                  >mdi-eye-off</v-icon
                >
              </template>
              <span>Ocultar columnas</span>
            </v-tooltip>
          </template>
          <v-list style="height: 250px; overflow-y: scroll">
            <v-list-item v-for="header in headers" :key="header.value">
              <v-switch
                @click="toggleColumnVisibility(header.value)"
                outlined
                small
                inset
              >
              </v-switch>
              <v-list-item-title>{{ header.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-title>
      <v-divider />
      <v-data-table
        :search="search"
        :hide-default-footer="true"
        disable-pagination
        :headers="getVisibleHeaders"
        :items="rows"
        fixed-header
        :height="calculateMaxHeight"
        class="elevation-3"
        :visible-columns="visibleColumns"
      >
      </v-data-table>
    </v-card>
    <div class="mt-5 d-flex justify-center pb-5">
      <v-btn class="bt-exit" @click="close">{{
        $tc("newController.close")
      }}</v-btn>
    </div>
  </v-card>
</template>

<script>
import liquidation from "../../store/liquidaciones/liquidation";
import ToolbarTitles from "../Complement/ToolbarTitles.vue";

export default {
  components: { ToolbarTitles },
  props: {
    closeDialog: Boolean,
    title: String,
    close: Function,
  },
  data() {
    return {
      search: "",
    };
  },
  computed: {
    headers() {
      return liquidation.state.headers.map((header) => ({
        text: header.replace(/_/g, " "),
        value: header,
        class: "primary secondary--text",
      }));
    },
    rows() {
      return liquidation.state.rows;
    },
    getVisibleHeaders() {
      return this.headers.filter((header) => {
        return this.visibleColumns[header.value];
      });
    },
    visibleColumns() {
      const initialColumns = {};
      this.headers.forEach((header) => {
        initialColumns[header.value] = true;
      });
      return { ...initialColumns, ...liquidation.state.visibleColumns };
    },
    calculateMaxHeight() {
      switch (true) {
        case this.rows?.length > 5:
          return "60vh";
      }
    },
  },
  methods: {
    toggleColumnVisibility(columnName) {
      const isVisible = !this.visibleColumns[columnName];

      liquidation.commit("setVisibleColumns", {
        columnName,
        isVisible,
      });
    },
  },
};
</script>

<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.button-container {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  margin-right: 10px;
  background-color: #d082c3;
}
.active {
  background-color: #82a1d0 !important;
  color: white;
}
.search {
  max-width: 500px;
}
::v-deep .v-data-table--fixed-header > .v-data-table__wrapper {
  overflow-y: scroll;
  scrollbar-width: unset;
}
@media (min-width: 1200px) and (max-width: 1500px) {
  .dataTable {
    max-height: 300px !important;
  }
}

@media (min-width: 300px) and (max-width: 1200px) {
  .dataTable {
    max-height: 350px !important;
  }
}

@media (min-width: 1500px) and (max-width: 1680px) {
  .dataTable {
    max-height: 500px !important;
  }
}

@media (min-width: 1681px) and (max-width: 2000px) {
  .dataTable {
    max-height: 450px !important;
  }
}
</style>
